import { render, staticRenderFns } from "./addons.vue?vue&type=template&id=7e9059e4&scoped=true&"
import script from "./addons.vue?vue&type=script&lang=js&"
export * from "./addons.vue?vue&type=script&lang=js&"
import style0 from "./addons.vue?vue&type=style&index=0&id=7e9059e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9059e4",
  null
  
)

export default component.exports